import { render, staticRenderFns } from "./DropdownLink.vue?vue&type=template&id=a5fdd6ac&"
import script from "./DropdownLink.vue?vue&type=script&lang=js&"
export * from "./DropdownLink.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/dropdown.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports